module.exports = __webpack_public_path__ + "static/media/T.6e507727.svg";